import MPendingAppointmentFeedbackCard from './MPendingAppointmentFeedbackCard.vue';

export { MPendingAppointmentFeedbackCard };
export default MPendingAppointmentFeedbackCard;
